import auth0 from 'auth0-js'

import GoogleLoginButtonBody from './GoogleLoginButtonBody'
import { Auth0Props } from '../../AuthForm'

export default (props: Auth0Props) => {
  if (!props?.AUTH0_DOMAIN || !props?.AUTH0_CLIENT_ID) return null
  const auth = new auth0.WebAuth({
    domain: props.AUTH0_DOMAIN,
    clientID: props.AUTH0_CLIENT_ID,
  })

  const authorize = () => {
    auth.authorize({
      scope: 'openid profile email',
      audience: 'https://' + props.AUTH0_DOMAIN + '/userinfo',
      connection: 'google-oauth2',
      responseType: 'id_token',
      redirectUri: `${window.location.origin}/${props.homepage}/login`,
    })
  }

  return <GoogleLoginButtonBody onPress={authorize} {...props} />
}
